<template>
  <div>
    <Nav title="规则" />
    <div class="lottery_rule_bg">
      <div class="lottery_rule_header_bg ">
        <img
          class="lottery_rule_header_image"
          src="../../assets/lottery/guize_img.png"
        />

        <div class="lottery_rule_content">
          <LotteryTitle class="lotteryTitle" titleName="活动内容" />
          <div
            class="lottery_rule_content_title"
            v-for="(value, index) in content"
            :key="index"
          >
            <span v-if="index != 0"> {{ value }}</span>
            <span v-for="(valu, ind) in contentRed" :key="ind">
              <span
                v-if="index == 0"
                class="lottery_rule_content_title_black"
                >{{ contentBlack[ind] }}</span
              >
              <span v-if="index == 0" class="lottery_rule_content_title_red">{{
                contentRed[ind]
              }}</span>
            </span>
          </div>
        </div>
        <div class="lottery_rule_content">
          <LotteryTitle class="lotteryTitle" titleName="开奖说明" />
          <div
            class="lottery_rule_content_title"
            v-for="(value, index) in description"
            :key="index"
          >
            <span v-if="index != 1"> {{ value }}</span>
            <br v-if="index != 1" />
            <span v-for="(valu, ind) in descriptionRed" :key="ind">
              <span
                v-if="index == 0"
                class="lottery_rule_content_title_black"
                >{{ descriptionBlack[ind] }}</span
              >
              <span v-if="index == 0" class="lottery_rule_content_title_red">{{
                descriptionRed[ind]
              }}</span>
            </span>
          </div>
        </div>
        <algorithm class="lottery_rule_algorithm" />
        <div class="lottery_rule_content">
          <LotteryTitle class="lotteryTitle" titleName="注意事项" />
          <div
            class="lottery_rule_content_title"
            v-for="(value, index) in precautions"
            :key="index"
          >
            {{ value }}
          </div>
        </div>
        <div class="lottery_rule_bottom_msg">
          活动最终解释权归北京爵维科技股份有限公司
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
import Nav from "../../components/nav/Nav.vue";
import Algorithm from "../../components/lottery/Algorithm.vue";
import LotteryTitle from "../../components/lottery/LotteryTit.vue";
import { LotteryRuleContent } from "../../hooks/LotteryRuleContent";
import { LotteryConfig } from "../../config/Lottery.conf";

@Options({
  components: { Nav, Algorithm, LotteryTitle }
})
export default class LotteryRule extends Vue {
  content: string[] = [];
  contentRed: string[] = [];
  contentBlack: string[] = [];
  description: string[] = [];
  descriptionRed: string[] = [];
  descriptionBlack: string[] = [];
  precautions: string[] = [];
  minPerson = 0;
  mounted() {
    this.minPerson = LotteryConfig.minPerson;
    this.content = LotteryRuleContent.content;
    this.contentRed = LotteryRuleContent.contentRed;
    this.contentBlack = LotteryRuleContent.contentBlack;
    this.description = LotteryRuleContent.description;
    this.descriptionRed = LotteryRuleContent.descriptionRed;
    this.descriptionRed[0] = this.descriptionRed[0].replace(
      "100",
      LotteryConfig.minPerson.toString()
    );
    this.descriptionBlack = LotteryRuleContent.descriptionBlack;
    this.precautions = LotteryRuleContent.precautions;
  }
}
</script>

<style lang="less">
.lottery_rule_bg {
  background-color: #f6f6f6;
  width: 100%;
  position: fixed;
  margin: 0 auto;
  left: 0px;
  bottom: 0;
  top: 44px;
  overflow-y: scroll;
  .lottery_rule_header_bg {
    height: 432px;
    background: -moz-linear-gradient(top, #ff1e1e 0%, #f5f5f5 100%);
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      color-stop(0%, #ff1e1e),
      color-stop(100%, #f5f5f5)
    );
    background: -webkit-linear-gradient(top, #ff1e1e 0%, #f5f5f5 100%);
    background: -o-linear-gradient(top, #ff1e1e 0%, #f5f5f5 100%);
    background: -ms-linear-gradient(top, #ff1e1e 0%, #f5f5f5 100%);
    background: linear-gradient(to bottom, #ff1e1e 0%, #f5f5f5 100%);
    .lottery_rule_header_image {
      width: 100%;
    }
  }

  /// 抽奖算法规则头 🔥title 🔥
  .lotteryTitle {
    padding: 0px 0px 16px 0px;
  }
  .lottery_rule_algorithm {
    margin-bottom: 10px;
  }
  // 内容 说明 算法 注意事项
  .lottery_rule_content {
    background-color: #ffffff;
    margin-bottom: 10px;
    margin-left: 20px;
    margin-right: 20px;
    padding: 20px;
    border-radius: 10px;
    .lottery_rule_content_title {
      text-align: left;
      font-size: 13px;
      color: #222222;
      .lottery_rule_content_title_red {
        color: #ff1e1e;
      }
      .lottery_rule_content_title_black {
        color: #222222;
      }
    }
  }
  .lottery_rule_bottom_msg {
    font-size: 13px;
    color: #222222;
    padding-top: 14px;
    padding-bottom: 24px;
    // margin: 10px 0px 24px 0px;
  }
}
</style>
